// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5a-6";
export var headerCell = "_5a-2";
export var rowWrapper = "_5a-4";
export var stickyAggregationCell = "_5a-a";
export var stickyAggregationRow = "_5a-7";
export var stickyColumnCell = "_5a-9";
export var stickyColumnHeaderCell = "_5a-8";
export var table = "_5a-1";
export var virtualRowWrapper = "_5a-5";
export var virtualTableContainer = "_5a-0";
export var white = "_5a-3";